import React, { useState } from 'react';
import { playThemeSound } from '../../../utils/themeAudio';

const DIYA_COUNT = 18;

const InteractiveDiyas = () => {
    const [sparkleIndex, setSparkleIndex] = useState(null);

    const handleDiyaTouch = (idx) => {
        setSparkleIndex(idx);
        playThemeSound('diwali', 'templeBell');
        setTimeout(() => setSparkleIndex(null), 800);
    };

    return (
        <div className="sticky top-0 mt-[55px] md:mt-[75px] mb-[-120px] md:mb-[-170px] left-0 right-0 h-16 md:h-22 pointer-events-none z-[62] overflow-hidden select-none">
            <div className="w-full h-full relative">
                <svg viewBox="0 0 1200 60" preserveAspectRatio="none" className="w-full h-full overflow-visible">
                    {/* Golden Marigold Flower Garland String */}
                    <path
                        d="M0 0 Q 300 65 600 0 Q 900 65 1200 0"
                        fill="none"
                        stroke="#f59e0b"
                        strokeWidth="3.5"
                    />

                    {/* 18 Hanging Ornate Golden Diyas & Brass Bells */}
                    {Array.from({ length: DIYA_COUNT }).map((_, i) => {
                        const x = i * (1200 / (DIYA_COUNT - 1));
                        const normalizedX = x % 600;
                        const t = normalizedX / 600;
                        const curveY = 2 * (1 - t) * t * 65;
                        const isSparkled = sparkleIndex === i;
                        const isBell = i % 3 === 0;

                        return (
                            <g
                                key={i}
                                transform={`translate(${x}, ${curveY})`}
                                className="pointer-events-auto cursor-pointer group"
                                onMouseEnter={() => handleDiyaTouch(i)}
                                onClick={() => handleDiyaTouch(i)}
                                onTouchStart={() => handleDiyaTouch(i)}
                            >
                                {/* Golden Brass Chain */}
                                <line x1="0" y1="-14" x2="0" y2="0" stroke="#f59e0b" strokeWidth="1.5" strokeDasharray="2,2" />

                                {isBell ? (
                                    /* Sacred Temple Brass Bell */
                                    <g>
                                        <path
                                            d="M -6 4 C -6 -2 6 -2 6 4 L 8 14 L -8 14 Z"
                                            fill="#f59e0b"
                                            stroke="#b45309"
                                            strokeWidth="1"
                                            className={isSparkled ? 'animate-bounce' : ''}
                                        />
                                        <circle cx="0" cy="16" r="2.5" fill="#78350f" />
                                    </g>
                                ) : (
                                    /* Traditional Clay Diya with Oil Flame */
                                    <g>
                                        {/* Clay Bowl */}
                                        <path
                                            d="M -10 6 Q 0 16 10 6 Q 8 14 0 16 Q -8 14 -10 6 Z"
                                            fill={isSparkled ? '#f59e0b' : '#b45309'}
                                            stroke="#78350f"
                                            strokeWidth="1"
                                            style={{
                                                filter: isSparkled ? 'drop-shadow(0 0 14px #fbbf24)' : 'drop-shadow(0 0 5px #f59e0b)',
                                                transform: isSparkled ? 'scale(1.3)' : 'scale(1)',
                                                transformOrigin: '0 8px',
                                                transition: 'all 0.2s ease',
                                            }}
                                        />

                                        {/* Glowing Flame */}
                                        <path
                                            d="M 0 -8 C -4 0 -3 4 0 6 C 3 4 4 0 0 -8 Z"
                                            fill="#fde047"
                                            className="animate-diya-flicker"
                                            style={{
                                                filter: isSparkled ? 'drop-shadow(0 0 18px #fef08a)' : 'drop-shadow(0 0 7px #f59e0b)',
                                                transform: isSparkled ? 'scale(1.5)' : 'scale(1)',
                                                transformOrigin: '0 0',
                                                transition: 'all 0.2s ease',
                                            }}
                                        />
                                    </g>
                                )}

                                {/* Marigold Flower Node */}
                                <circle cx="0" cy="-2" r="4.5" fill={i % 2 === 0 ? '#f97316' : '#eab308'} stroke="#c2410c" strokeWidth="0.8" />

                                {/* Sparkle Indicator when touched */}
                                {isSparkled && (
                                    <text x="0" y="-12" textAnchor="middle" fontSize="12" fill="#fef08a" className="animate-bounce font-bold">
                                        ✨
                                    </text>
                                )}
                            </g>
                        );
                    })}
                </svg>
            </div>
        </div>
    );
};

export default InteractiveDiyas;
